/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import LoaderComponent from '../common/LoaderComponent';
import AccountsStore from '../../stores/AccountsStore';
import LegacyAccountsStore from '../../stores/AccountsStore/AccountsStore';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import MessageStore from '../../stores/MessageStore';
import SecurityDeviceStore from '../../stores/SecurityDeviceStore';
import MTrackStore from '../../stores/MTrackStore';
import AccountsActionCreator from '../../actions/AccountsActionCreator/AccountsActionCreator';
import FavouritesActionCreator from '../../actions/AccountsActionCreator/FavouritesActionCreator';
import StatementsPreferencesActionCreator from '../../actions/StatementsPreferencesActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import ManagePaymentActionCreator from '../../actions/ManagePaymentActionCreator';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import MessageActionCreator from '../../actions/MessageActionCreator';
import SecurityDeviceActionCreator from '../../actions/SecurityDeviceActionCreator';
import UserManagementActionCreator from '../../actions/UserManagementActionCreator';
import {
  dismissLastLoginAlert,
  initLastLoginAlert,
} from '../../actions/LastLoginActionCreator';
import { getMTrackEnabled } from '../../actions/MTrackActionCreator';
import NonBCustomerError from '../common/NonBCustomerError';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import FastLinks from './FastLinks';
import PasswordResetAlert from './PasswordResetAlert';

import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import NBABL from '../nba/NBABL';
import NBAStore from '../../stores/NBAStore';
import NBAActionCreator from '../../actions/NBAActionCreator';
import NBAPayload from '../nba/NBAPayload';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import StringConstants from '../../constants/StringConstants';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import envConfig from '../../../static/config';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import NavigateToWebApps from '../../utils/NavigateToWebApps';
import { getAllVerification } from '../../actions/UserVerificationActionCreator';
import { saveNavigationReference } from '../../actions/PaymentStatusActionCreator';
import UserVerificationStore from '../../stores/UserVerificationStore';
import VerificationAlert from './VerificationAlert';
import UserManagementStore from '../../stores/UserManagementStore';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import MasterCardAlertActionCreator from '../../actions/MasterCardAlertActionCreator';
import MasterCardAlertStore from '../../stores/MasterCardAlertStore';
import { PaperlessPreferencesSplash } from '../financial-stories/PaperlessPreferencesSplash/PaperlessPreferencesSplash';
import { isB } from '../../utils/BrandUtils';
import AccountPickerWrapper from '../accountpicker/AccountPickerWrapper';
import HomepageAccounts from './HomepageAccounts';
import { BioCatchContext } from '../BioCatchContext';
import { HOME_PAGE_CONTEXT } from '../../config/BioCatch';
import LastLoginStore from '../../stores/LastLoginStore';
import { LastLoginAlert } from '../last-login';
import PreferencesApiUtils from '../../utils/PreferencesApiUtils';
import { NBA_SPLASH_MARKETING_PREFERENCES_OFFER_ID } from '../../constants/NBASplashOffers';

const getNumberOfVerifications = () => {
  return UserVerificationStore.getAllVerification().length;
};

const handleSelectAccount = () => {
  InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
};

export class HomePage extends Component {
  constructor(props) {
    super(props);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onNBAStoreChange = this.onNBAStoreChange.bind(this);
    this.onMessageStoreChange = this.onMessageStoreChange.bind(this);
    this.onSecurityDeviceStoreChange =
      this.onSecurityDeviceStoreChange.bind(this);
    this.retryServices = this.retryServices.bind(this);
    this.continueAction = this.continueAction.bind(this);
    this.cancelAction = this.cancelAction.bind(this);
    this.getModalFooter = this.getModalFooter.bind(this);
    this.getModalBody = this.getModalBody.bind(this);
    this.getModalHeading = this.getModalHeading.bind(this);
    this.invokeModal = this.invokeModal.bind(this);
    this.splashAck = this.splashAck.bind(this);
    this.closeAction = this.closeAction.bind(this);
    this.fastLinkAdvertClick = this.fastLinkAdvertClick.bind(this);
    this.handleActivateTokenClick = this.handleActivateTokenClick.bind(this);
    this.onUserVerificationStoreChange =
      this.onUserVerificationStoreChange.bind(this);
    this.onUserManagementStoreChange =
      this.onUserManagementStoreChange.bind(this);
    this.getTilesOrGrid = this.getTilesOrGrid.bind(this);
    this.onMTrackStoreChange = this.onMTrackStoreChange.bind(this);

    const numberOfVerifications = getNumberOfVerifications();
    this.state = {
      accounts: AccountsStore.getAll(),
      hasAccountsLoaded:
        AccountsStore.getLoad() || this.props.largeCustomerEnabled,
      hasUserDetailsLoaded: UserManagementStore.getUserDetailsLoad(),
      error: AccountsStore.getErrorFlag(),
      status: AccountsStore.getStatus(),
      nbaData: NBAStore.getNBAData(),
      nbaSettings: NBAStore.getUserSettings(),
      shouldRenderLastLoginAlert: LastLoginStore.shouldRenderAlert(),
      showModal: false,
      nbaAction: {},
      count: MessageStore.getMessageCount(),
      shouldActivateHardToken: SecurityDeviceStore.hasOrderedToken(),
      splashRedirectTo: null,
      splashRedirectToBrochureware: false,
      showVerificationAlert: numberOfVerifications > 0,
      showPreferencesModal: false,
      numberOfVerifications,
      hasMTrackWhitelistLoaded: MTrackStore.getMTrackWhitelistLoaded(),
    };
  }

  componentWillMount() {
    SecurityDeviceStore.addChangeListener(this.onSecurityDeviceStoreChange);
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
    if (envConfig.isNBAEnabled) {
      if (NBAStore.doCallNba()) {
        NBAActionCreator.requestNBASettings();
        NBAStore.addChangeListener(this.onNBAStoreChange);
      }
    } else {
      NBABL.callAccountService();
    }

    if (!this.props.largeCustomerEnabled) {
      AccountsActionCreator.getAccountsList();
    }

    if (envConfig.isHardTokenActivationEnabled && !isB()) {
      SecurityDeviceActionCreator.getSecurityDevices();
    }
    if (envConfig.isSecureMessageEnabled) {
      MessageStore.addChangeListener(this.onMessageStoreChange);
      MessageActionCreator.getMessageCount();
    }
    !this.state.hasUserDetailsLoaded &&
      UserManagementActionCreator.getUserDetails();
    LegacyAccountsStore.addChangeListener(this.onStoreChange);
    FavouritesStore.addChangeListener(this.onStoreChange);
    getAllVerification();
    UserVerificationStore.addChangeListener(this.onUserVerificationStoreChange);
    if (!_.get(MoveMoneyStore.getAllPayees(), 'beneficiaries')) {
      MoveMoneyActionCreator.getFromPayeeList();
    }
    UserManagementStore.addChangeListener(this.onUserManagementStoreChange);

    if (this.props.largeCustomerEnabled) {
      FavouritesActionCreator.getQuickLinkPermissions();
    }

    MTrackStore.addChangeListener(this.onMTrackStoreChange);
    !this.state.hasMTrackWhitelistLoaded && getMTrackEnabled();

    const isBusinessUser = UserManagementStore.isBusinessUser();

    if (!isBusinessUser) {
      LastLoginStore.addChangeListener(this.onLastLoginStoreChange);
      if (!LastLoginStore.isAlertInitialised()) {
        initLastLoginAlert();
      }
    }

    // Business preferences call for SME CA only
    if (isBusinessUser) {
      const corporateAdminDetails = UserManagementStore.getCADetails();
      const customerId = corporateAdminDetails.customers[0].customer_id;
      PreferencesApiUtils.getBusinessPreferences(customerId);
    }
  }

  componentDidMount() {
    sayLandingMessage('Accounts');
  }

  componentWillUnmount() {
    if (envConfig.isNBAEnabled) {
      NBAStore.removeChangeListener(this.onNBAStoreChange);
    }
    UserVerificationStore.removeChangeListener(
      this.onUserVerificationStoreChange
    );
    if (envConfig.isSecureMessageEnabled) {
      MessageStore.removeChangeListener(this.onMessageStoreChange);
    }
    SecurityDeviceStore.removeChangeListener(this.onSecurityDeviceStoreChange);
    UserManagementStore.removeChangeListener(this.onUserManagementStoreChange);
    LegacyAccountsStore.removeChangeListener(this.onStoreChange);
    FavouritesStore.removeChangeListener(this.onStoreChange);
    MTrackStore.removeChangeListener(this.onMTrackStoreChange);
    LastLoginStore.removeChangeListener(this.onLastLoginStoreChange);

    if (LastLoginStore.shouldRenderAlert()) {
      dismissLastLoginAlert();
    }
  }

  onMessageStoreChange() {
    this.setState({
      count: MessageStore.getMessageCount(),
    });
  }

  onLastLoginStoreChange = () => {
    this.setState({
      shouldRenderLastLoginAlert: LastLoginStore.shouldRenderAlert(),
    });
  };

  onNBAStoreChange() {
    this.setState(
      {
        nbaData: NBAStore.getNBAData(),
        nbaSettings: NBAStore.getUserSettings(),
        showModal: NBABL.isSplashEnabled(
          NBAStore.getUserSettings(),
          NBAStore.getNBAData()
        ),
      },
      () => {}
    );
    if (
      (NBAStore.getSplashAckStatus() === 200 ||
        NBAStore.getSplashAckStatus() === 0) &&
      !_.isNil(this.state.splashRedirectTo)
    ) {
      if (this.state.splashRedirectToBrochureware) {
        NavigateToWebApps.navigateToBrochurewarePage(
          this.state.splashRedirectTo,
          true
        );
        return;
      }
      NavigateToWebApps.navigateTo(this.state.splashRedirectTo);
    }
  }

  onSecurityDeviceStoreChange() {
    this.setState({
      shouldActivateHardToken: SecurityDeviceStore.hasOrderedToken(),
    });
  }

  onStoreChange() {
    this.setState({
      accounts: AccountsStore.getAll(),
      hasAccountsLoaded:
        AccountsStore.getLoad() || this.props.largeCustomerEnabled,
      error: AccountsStore.getErrorFlag(),
      status: AccountsStore.getStatus(),
    });
  }

  onUserManagementStoreChange() {
    const userManagementLoadedFlag = UserManagementStore.getUserDetailsLoad();
    if (userManagementLoadedFlag !== this.state.hasUserDetailsLoaded) {
      this.setState({
        hasUserDetailsLoaded: userManagementLoadedFlag,
      });
    }
  }

  onUserVerificationStoreChange() {
    const numberOfVerifications = getNumberOfVerifications();
    this.setState({
      showVerificationAlert: numberOfVerifications > 0,
      numberOfVerifications,
    });
  }

  onMTrackStoreChange() {
    const mTrackWhitelistLoadedFlag = MTrackStore.getMTrackWhitelistLoaded();
    if (mTrackWhitelistLoadedFlag !== this.state.hasMTrackWhitelistLoaded) {
      this.setState({ hasMTrackWhitelistLoaded: mTrackWhitelistLoadedFlag });
    }
  }

  getModalBody() {
    if (
      NBABL.isSplashEnabled(this.state.nbaSettings, this.state.nbaData) &&
      _.isEmpty(this.state.nbaAction)
    ) {
      const data = NBABL.getSplashData(this.state.nbaData);
      if (
        _.has(data.textValue, 'textSubHeader') ||
        _.has(data.textValue, 'textValueParts')
      ) {
        let paras = [];
        _.forEach(data.textValue.textValueParts, (part, id) => {
          paras.push(<p>{part}</p>);
        });
        return (
          <div>
            {data.textValue.textSubHeader && (
              <h2>{data.textValue.textSubHeader}</h2>
            )}
            {paras}
            {data.textValue.textTnC && <p>{data.textValue.textTnC}</p>}
          </div>
        );
      } else {
        return <div dangerouslySetInnerHTML={{ __html: data.textValue }} />;
      }
    } else {
      return (
        <div>
          <p>{this.props.content.HelpPopupContent1}</p>
          <p>{this.props.content.HelpPopupContent2}</p>
        </div>
      );
    }
  }

  getModalFooter() {
    if (
      NBABL.isSplashEnabled(this.state.nbaSettings, this.state.nbaData) &&
      _.isEmpty(this.state.nbaAction)
    ) {
      const data = NBABL.getSplashData(this.state.nbaData);

      const { actionUrl: splashActions } = data;

      return splashActions.map(({ label, url }) => {
        if (url === '/splash/acknowledge') {
          return (
            <NavigationButton.Primary
              labelText={label}
              onClick={() => this.splashAck(url)}
            />
          );
        } else {
          return (
            <NavigationButton.Secondary
              labelText={label}
              onClick={() => this.splashAck(url)}
            />
          );
        }
      });
    } else {
      return (
        <div className="button-group">
          <button
            className="c-btn c-modal__button c-btn--secondary"
            tabIndex="0"
            onClick={this.cancelAction}
          >
            {this.props.content.cancelButtonText}
          </button>
          <button
            className="c-btn c-modal__button c-btn--default"
            tabIndex="0"
            onClick={this.continueAction}
          >
            {this.props.content.continueButtonText}
          </button>
        </div>
      );
    }
  }

  getModalHeading() {
    if (
      NBABL.isSplashEnabled(this.state.nbaSettings, this.state.nbaData) &&
      _.isEmpty(this.state.nbaAction)
    ) {
      return NBABL.getSplashData(this.state.nbaData).textHeader;
    } else {
      return <strong>{this.props.content.PopupHeading}</strong>;
    }
  }

  cancelAction() {
    NBABL.sendUserFeedBackHomePage(
      this.state.nbaAction,
      config.analytics.analytics_behaviour_negative
    );
    this.setState({ showModal: false });
  }

  closeAction() {
    NBABL.sendUserFeedBackHomePage(
      this.state.nbaAction,
      config.analytics.analytics_behaviour_neutral
    );
    this.setState({ showModal: false });
  }

  continueAction() {
    const url = NBABL.getCompletePath(this.state.nbaAction.actionUrl[0].url);
    NBABL.sendUserFeedBackHomePage(
      this.state.nbaAction,
      config.analytics.analytics_behaviour_positive
    );
    window.open(url, '_blank');
    this.setState({ showModal: false });
  }

  fastLinkAdvertClick(id) {
    switch (id) {
      case 'payments':
        InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
        break;
      case 'managepayments':
        ManagePaymentActionCreator.saveNavigationReference('WEB-HOMEPAGE');
        InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT');
        break;
      case 'stmtpref':
        StatementsPreferencesActionCreator.setBackPageReference('WEB-HOMEPAGE');
        InternetBankingActions.navigateToWebTask('WEB-STATEMENTS-PREFERENCES');
        break;
      case 'pots':
        SavingsPotsStore.getMoveMoneyAccountIndex();
        SavingPotsActionCreator.saveNavigationReference('WEB-HOMEPAGE');
        InternetBankingActions.navigateToWebTask('WEB-OPEN-SAVING-POTS');
        break;
      case 'alerts':
        const singleAlertAccountID =
          AccountsStore.getAlertsAvailableSingleAccount();
        singleAlertAccountID
          ? MasterCardAlertActionCreator.setManageAlertsAccountID(
              singleAlertAccountID
            )
          : MasterCardAlertActionCreator.setManageAlertsAccountID();
        MasterCardAlertStore.setNavigation('WEB-HOMEPAGE');
        InternetBankingActions.navigateToWebTask('WEB-OPEN-ALERTS');
        break;
      case 'spending':
        InternetBankingActions.navigateToWebTask('WEB-OPEN-SPENDINGS');
        break;
      case 'manageaccountpools':
        InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-POOLS');
        break;
      case 'marketplace':
        NavigateToWebApps.navigateTo(envConfig.marketplaceLink);
        break;
      case 'vulnerable-customers':
        NavigateToWebApps.navigateToVulnerableCustomersWebAppPage();
        break;
      case 'brochureware-your-support':
        NavigateToWebApps.navigateToBrochurewareYourSupportPage();
        break;
      default:
        break;
    }
  }

  goToAccountDetails(id) {
    AccountsActionCreator.setAccountID(id);
    InternetBankingActions.clearWebTask();
    // Don't call Account Details, move the balance object over instead
    // TODO: Could add isSMEUser here to save on account-details call for SME Credit card users
    const accountType = AccountsStore.getAccountTypeFromAccountId(id);
    if (accountType && accountType.toLowerCase() === 'credit_card') {
      AccountsActionCreator.getAccountDetails(id);
    } else {
      AccountsStore.setAccountDetailsBalance();
    }

    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
  }

  handleActivateTokenClick() {
    InternetBankingActions.navigateToWebTask(
      'WEB-ACTIVATE-YOUR-SECURITY-TOKEN'
    );
  }

  invokeModal(data) {
    const selectedNba = data;
    this.setState({ showModal: true, nbaAction: selectedNba });
  }

  navigatePaymentStatus() {
    saveNavigationReference('WEB-HOMEPAGE');
    InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT-STATUS');
  }

  retryServices() {
    AccountsActionCreator.getAccountsList();
  }

  splashAck(event) {
    const isBrowserEvent = !!event.target;

    if (isBrowserEvent) {
      event.stopPropagation();
      event.preventDefault();
    }

    const splash = NBABL.getSplashData(this.state.nbaData);
    const { content } = this.props;

    const callAccountsService = () => {
      NBABL.callAccountService();
    };

    const sendSplashAck = () => {
      NBAActionCreator.sendSplashAcknowledgement(
        StringConstants.ACCTSUMM,
        NBAPayload.nbaContainerUserInteraction(
          splash.id,
          splash.offerId,
          config.analytics.analytics_behaviour_negative
        )
      );
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_cta,
        NBABL.getAnalyticsData(
          splash,
          config.analytics.analytics_behaviour_negative
        )
      );
      AnalyticsActionCreator.requestImmediateDispatch();
    };

    const action = isBrowserEvent ? event.target.value : event;

    switch (action) {
      case '/user/preferences':
        this.setState({
          showModal: false,
          splashRedirectTo: envConfig.marketingPreferenceLink,
        });
        sendSplashAck();
        break;
      case '/splash/exit':
        this.setState({ showModal: false });
        callAccountsService();
        sendSplashAck();
        break;
      case '/paperless/confirm':
        AccountsActionCreator.getAccountsList();
        this.setState({ showPreferencesModal: true });
        break;
      case '/splash/cop':
        this.setState({
          showModal: false,
          splashRedirectTo: content.paymentCOPUrl,
          splashRedirectToBrochureware: true,
        });
        NBAActionCreator.sendSplashAcknowledgement(
          StringConstants.ACCTSUMM,
          NBAPayload.nbaContainerUserInteraction(
            splash.id,
            splash.offerId,
            config.analytics.analytics_behaviour_positive
          )
        );
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_cta,
          NBABL.getAnalyticsData(
            splash,
            config.analytics.analytics_behaviour_positive
          )
        );
        AnalyticsActionCreator.requestImmediateDispatch();
        break;
      case '/splash/capability5':
      case '/splash/acknowledge':
        const { offerId = '' } = splash;
        this.setState({
          showModal: false,
          ...(offerId === NBA_SPLASH_MARKETING_PREFERENCES_OFFER_ID && {
            splashRedirectTo: envConfig.marketingPreferenceLink,
          }),
        });
        NBAActionCreator.sendSplashAcknowledgement(
          StringConstants.ACCTSUMM,
          NBAPayload.nbaContainerUserInteraction(
            splash.id,
            splash.offerId,
            config.analytics.analytics_behaviour_positive
          )
        );
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_cta,
          NBABL.getAnalyticsData(
            splash,
            config.analytics.analytics_behaviour_positive
          )
        );
        AnalyticsActionCreator.requestImmediateDispatch();
        break;
      default:
        callAccountsService();
        break;
    }
  }

  getTilesOrGrid({ includeAccounts, className }) {
    const { nbaData, shouldActivateHardToken, count, accounts } = this.state;
    const { largeCustomerEnabled } = this.props;

    return (
      <HomepageAccounts
        includeAccounts={includeAccounts}
        accounts={accounts}
        content={this.props.content}
        className={className}
        invokeModal={this.invokeModal}
        nbaData={nbaData}
        advertClick={this.fastLinkAdvertClick}
        goToAccountDetails={this.goToAccountDetails}
        shouldActivateHardToken={shouldActivateHardToken}
        handleActivateTokenClick={this.handleActivateTokenClick}
        messageCount={count}
        isSMEUser={UserManagementStore.isSMEUser()}
        isLCV={largeCustomerEnabled}
      />
    );
  }

  renderTiles() {
    const { largeCustomerEnabled, session, content } = this.props;
    const { accounts } = this.state;

    const user = UserManagementStore.getCADetails();

    if (largeCustomerEnabled) {
      return (
        <section className="sme-lcv-layout">
          <div className="accountpicker sme-lcv-layout-column1">
            <AccountPickerWrapper
              user={user}
              session={session}
              favourites={accounts}
              onSelectAccount={handleSelectAccount}
              content={content}
            />
          </div>
          {this.getTilesOrGrid({
            includeAccounts: false,
            className: 'sme-lcv-layout-column2',
          })}
        </section>
      );
    }

    return this.getTilesOrGrid({ includeAccounts: true, className: 'l-tiles' });
  }

  render() {
    let headerContent = "Something's gone wrong";
    let bodyContent1 = "Sorry, it looks like there's been a technical problem.";
    let bodyContent2 = '';
    const {
      showVerificationAlert,
      numberOfVerifications,
      hasAccountsLoaded,
      hasUserDetailsLoaded,
    } = this.state;
    const showAccounts = hasAccountsLoaded && hasUserDetailsLoaded;
    const showVerificationAlertMessage =
      UserManagementStore.isBusinessUser() &&
      !!numberOfVerifications &&
      showVerificationAlert;

    return (
      <BioCatchContext context={HOME_PAGE_CONTEXT}>
        <div>
          <Helmet title="Accounts" />
          {this.state.error ? (
            <div className="error-space">
              <NonBCustomerError
                headerContent={
                  this.state.status === 409
                    ? this.props.content.accountStatusHeaderContent
                    : headerContent
                }
                buttonName2="Retry"
                bodyContent1={
                  this.state.status === 409
                    ? this.props.content.accountStatusBodyContent
                    : bodyContent1
                }
                bodyContent2={bodyContent2}
                handleButtonClick2={this.retryServices}
                headerFlag
                hideButton1
                componentName
                page
              />
            </div>
          ) : (
            <div className="page page-home bow">
              {showAccounts ? (
                <div
                  id="site-main"
                  className="container"
                  role="main"
                  tabIndex="-1"
                >
                  <PasswordResetAlert />
                  {this.state.shouldRenderLastLoginAlert && <LastLoginAlert />}
                  <VerificationAlert
                    onClose={() =>
                      this.setState({
                        showVerificationAlert: !showVerificationAlert,
                      })
                    }
                    isOpen={showVerificationAlertMessage}
                    navigatePaymentStatus={this.navigatePaymentStatus}
                    content={this.props.content}
                    numberOfVerifications={numberOfVerifications}
                  />
                  <div className="row">
                    <div className="col-md1-24">
                      <FastLinks onLinkClick={this.fastLinkAdvertClick} />
                      {this.renderTiles()}
                    </div>
                  </div>
                </div>
              ) : (
                <LoaderComponent type="large" />
              )}
              <PaperlessPreferencesSplash
                nbaData={this.state.nbaData}
                content={this.props.content}
                show={
                  this.state.showPreferencesModal &&
                  !UserManagementStore.isSMEUser()
                }
                onHide={() =>
                  this.setState({
                    showPreferencesModal: false,
                    showModal: false,
                  })
                }
                hasAccountsLoaded={this.state.hasAccountsLoaded}
              />
              <PatternLibModalComponent
                show={this.state.showModal}
                onHide={this.closeAction}
                bsSize={'medium'}
                modalHeading={this.getModalHeading()}
                modalBody={this.getModalBody()}
                modalFooter={this.getModalFooter()}
                customClass={'c-modal c-modal--pre-line'}
                closeButton={NBABL.isPopupHasCrossIcon(
                  this.state.nbaSettings,
                  this.state.nbaData,
                  this.state.nbaAction
                )}
                backdrop="static"
              />
            </div>
          )}
        </div>
      </BioCatchContext>
    );
  }
}

HomePage.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(HomePage);
